/* eslint-disable */
import throwMethodNotImplementedError from '../../../Errors/General/MethodNotImplemented.error';

/**
 * AnalyticsAdapter
 * @class AnalyticsAdapter
 * @implements {AnalyticsServiceAdapterContract}
 */
class AnalyticsAdapter {
  /**
   * Add an Analytics script to the page
   * @returns {void} void
   * @memberof AnalyticsAdapter
   */
  addScript = () => {
    return throwMethodNotImplementedError(`addScript`);
  };

  /**
   * Track an event
   * @param {AnalyticsEvent} event The event to track
   * @returns {void} void
   * @memberof AnalyticsAdapter
   */
  track = (event) => {
    return throwMethodNotImplementedError(`track`);
  };
}

export default AnalyticsAdapter;
